import { LandingPage } from "@/pages/LandingPage.js";
import { SolgtComPage } from "@/pages/SolgtComPage.js";
import { useConfig } from "@nmp-js/huck/client";
import React from "react";
import { Config } from "../types.js";

export const App: React.FC = () => {
	const config: Config = useConfig<Config>();
	const { isGuaranteedSalePage } = config;
	return <>{isGuaranteedSalePage ? <SolgtComPage /> : <LandingPage />}</>;
};
